import React from 'react'

import { SearchForm } from '@/components/Forms/SearchForm'

import { useSearch } from '../SearchProvider'
import { Container, Content, SubmitWrapper } from './styles'

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface LeftContentProps {}

export const LeftContent = (_: LeftContentProps) => {
  const { searchParams, search } = useSearch()

  return (
    <Container>
      <SearchForm
        values={searchParams}
        onSubmit={(values) => {
          search({
            ...values,
            // Reset cityCode, tags and page on search
            cityCode: undefined,
            tags: [],
            page: 1,
          })
        }}
      >
        {({ fields, submit }) => (
          <>
            <Content>{fields}</Content>
            <SubmitWrapper>{submit}</SubmitWrapper>
          </>
        )}
      </SearchForm>
    </Container>
  )
}
